import { render, staticRenderFns } from "./pubgoods.vue?vue&type=template&id=37010d5e&scoped=true"
import script from "./pubgoods.vue?vue&type=script&lang=js"
export * from "./pubgoods.vue?vue&type=script&lang=js"
import style0 from "./pubgoods.vue?vue&type=style&index=0&id=37010d5e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37010d5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37010d5e')) {
      api.createRecord('37010d5e', component.options)
    } else {
      api.reload('37010d5e', component.options)
    }
    module.hot.accept("./pubgoods.vue?vue&type=template&id=37010d5e&scoped=true", function () {
      api.rerender('37010d5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/pubgoods.vue"
export default component.exports